<app-header></app-header>

<section class="login">
  @if (loading) {
  <div class="font-bold text-m">
    {{ "LOADING..." | translate }}
  </div>
  } @else { @if (!loading && isTokenValid) {
  <h1>{{ "ACCOUNT_ACTIVATED" | translate }}</h1>
  <p class="mb-5">{{ "ACCOUNT_ACTIVATED_REDIRECT" | translate }}</p>
  <a
    routerLink="/onboarding"
    [queryParams]="{redirectTo: workResumeUrl}"
    class="btn full"
  >
    {{ "DISCOVER_GEMSTER" | translate }}
  </a>
  } @else {
  <h1>{{ "ACTIVATION_LINK_EXPIRED" | translate }}</h1>
  <app-account-activation-form></app-account-activation-form>
  } }
</section>
